import { registerCapability } from '../../platform/capability-registry';
import { RunPolicyBlock } from './RunPolicyBlock';
import { RUN_POLICY_FIELD_KEY_LIST } from './fieldKeys';
import { resolveRunPolicyPaths } from './resolvePaths';
import type { RunPolicyBlockOptions } from './types';

registerCapability<RunPolicyBlockOptions>({
  key: 'run-policy',
  fields: [...RUN_POLICY_FIELD_KEY_LIST],
  component: RunPolicyBlock,
  defaultPaths: (prefix) => resolveRunPolicyPaths(prefix),
  resolvePaths: (prefix, options) => resolveRunPolicyPaths(prefix, options),
});
